import { Box, TextField, Button } from "@material-ui/core"
import { useState } from "react"
import { useLogic } from "../../../../../hooks/storeHook"

type LinkCardWbProps = {
  variantCardId?: string
}

export const LinkCardWb: React.FC<LinkCardWbProps> = ({ variantCardId }) => {
  const [vendorCode, setVendorCode] = useState("")
  const [isLinking, setIsLinking] = useState(false)
  const logic = useLogic()

  const handleLink = async () => {
    if (!variantCardId || !vendorCode) return
    setIsLinking(true)

    try {
      const message = await logic.api.mpCard.linkVariant({ variantCardId: variantCardId ?? "0", vendorCode })
      alert(message)
    } catch (e) {
      alert("Ошибка при добавлении варианта")
    } finally {
      setIsLinking(false)
    }
  }

  return (
    <Box
      mt={2}
      mb={2}
      display="flex"
      alignItems="center"
      width="100%"
      justifyContent="flex-start"
    >
      <TextField
        label="Vendor Code/Артикул основной карточки"
        value={vendorCode}
        onChange={(e) => setVendorCode(e.target.value)}
        variant="outlined"
        size="small"
        style={{ marginRight: 8, marginBottom: 4, flex: 1 }}
        disabled={isLinking}
      />
      <Button
        type="button"
        color="primary"
        onClick={handleLink}
        disabled={isLinking}
      >
        {isLinking ? "Идет привязка..." : "Привязать"}
      </Button>
    </Box>
  )
}
